import { verifyEmail } from './auth-api';
import { t } from '../../engine/i18n';

export function renderVerifyEmail(root: HTMLElement, token: string): () => void {
  root.innerHTML = `
    <div class="min-h-screen grid place-items-center px-5 py-10 bg-auth-gradient">
      <div class="w-full max-w-[420px] bg-auth-card border border-border rounded-lg p-8 shadow-lift">
        <h1 class="mb-2 font-heading text-2xl text-gold tracking-wide">${t('auth.verify.heading')}</h1>
        <p id="verify-status" class="mb-6 text-sm text-text-dim">${t('auth.verify.status')}</p>
        <p class="mt-5 text-[13px] text-text-dim text-center"><a href="/login">${t('auth.verify.backToSignIn')}</a></p>
      </div>
    </div>
  `;
  const status = root.querySelector('#verify-status') as HTMLElement;

  verifyEmail(token)
    .then(() => {
      status.textContent = t('auth.verify.success');
    })
    .catch((err) => {
      status.textContent = t('auth.verify.failed', { error: (err as Error).message });
    });

  return () => { /* noop */ };
}
